const cardObj = {
  // Graphic Control Measures - Area - Areas
  'gcm-icons': [
    ['.gcm-areas-ao', 'Area of Operations'],
    ['.gcm-areas-aa', 'Assembly Area'],
    ['.gcm-areas-bc', 'Base Camp'],

    ['.gcm-areas-ea', 'Engagement Area'],
    ['.gcm-areas-gb', 'Guerilla Base'],
    ['.gcm-areas-nai', 'Named Area of Interest'],

    ['.gcm-areas-oa', 'Objective Area'],
    ['.gcm-areas-tai', 'Targeted Area of Interest'],
    ['.gcm-areas-ap', 'Assault Position'],

    ['.gcm-areas-atk', 'Attack Position'],
    ['.gcm-areas-dha', 'Detainee Holding Area'],
    ['.gcm-areas-rha', 'Refugee Holding Area'],

    ['.gcm-areas-farp', 'Forward Arming and Refuelling Point'],
    ['.gcm-areas-bsa', 'Brigade Support Area'],
    ['.gcm-areas-dsa', 'Division Support Area'],

    ['.gcm-areas-csa', 'Corps Support Area'],
    ['.gcm-areas-airfield', 'Airfield Zone'],
    ['.gcm-areas-dz', 'Drop Zone'],

    ['.gcm-areas-lz', 'Landing Zone'],
    ['.gcm-areas-pz', 'Pickup Zone'],
    ['.gcm-areas-bp', 'Battle Position'],

    ['.gcm-areas-bppbnp', 'Battle Position Planned but not Prepared'],
    ['.gcm-areas-bppbno', 'Battle Position Planned but not Occupied'],
    ['.gcm-areas-strongPoint', 'Strong Point'],

    ['.gcm-areas-fortified', 'Fortified Area'],
    ['.gcm-areas-uxo', 'UXO Area'],
    ['.gcm-areas-encirclement', 'Encirclement Operations'],
  ],

  'gcm-icons-points': [
    ['.gcm-points-checkpoint', 'Checkpoint'],
    ['.gcm-points-control', 'Control Point'],
    ['.gcm-points-erp', 'Engineer Regulating Point'],

    ['.gcm-points-linkup', 'Linkup Point'],
    ['.gcm-points-passage', 'Passage Point'],
    ['.gcm-points-rally', 'Rally Point'],

    ['.gcm-points-release', 'Release Point'],
    ['.gcm-points-sp', 'Start Point'],
    ['.gcm-points-pod', 'Point of Departure'],

    ['.gcm-points-amnesty', 'Amnesty Point'],
    ['.gcm-points-civ', 'Civilian Collection Point'],
    ['.gcm-points-dcp', 'Detainee Collection Point'],

    ['.gcm-points-isolated', 'Isolated Personnel Recovery Point'],
    ['.gcm-points-sar', 'Search and Rescue Point'],
    ['.gcm-points-decon', 'Decontamination Point'],

    ['.gcm-points-altdecon', 'Alternate Decontamination Point'],
    ['.gcm-points-eqdecon', 'Equipment Decontamination Point'],
    ['.gcm-points-troopdecon', 'Troop Decontamination Point'],

    ['.gcm-points-etdecon', 'Equipment or Troop Decontamination Point'],
    ['.gcm-points-odecon', 'Operational Decontamination Point'],
    ['.gcm-points-thdecon', 'Thorough Decontamination Point'],

    ['.gcm-points-medecon', 'Main Equipment Decontamination Point'],
    ['.gcm-points-ftdecon', 'Forward Troop Decontamination Point'],
    ['.gcm-points-wdecon', 'Wounded Personnel Decontamination Point'],

    ['.gcm-points-firing', 'Firing Point'],
    ['.gcm-points-hide', 'Hide Point'],
    ['.gcm-points-launch', 'Launch Point'],

    ['.gcm-points-reload', 'Reload Point'],
    ['.gcm-points-scp', 'Survey Control Point'],
    ['.gcm-points-axp', 'Ambulance Exchange Point'],

    ['.gcm-points-acp', 'Ambulance Control Point'],
    ['.gcm-points-alp', 'Ambulance Load Point'],
    ['.gcm-points-arp', 'Ambulance Relay Point'],

    ['.gcm-points-asp', 'Ammunition Supply Point'],
    ['.gcm-points-athp', 'Ammunition Transfer Holding Point'],
    ['.gcm-points-can', 'Cannibalization Point'],

    ['.gcm-points-ccp', 'Casualty Collection Point'],
    ['.gcm-points-lrp', 'Logistics Release Point'],
    ['.gcm-points-mcp', 'Maintenance Collection Point'],

    ['.gcm-points-mepp', 'Medical Evacuation Pickup Point'],
    ['.gcm-points-macp', 'Mortuary Affairs Collection Point'],
    ['.gcm-points-r3p', 'Rearm, Refuel and Resupply Point'],

    ['.gcm-points-tcp', 'Traffic Control Point (TCP)'],
    ['.gcm-points-ttp', 'Trailer Transfer Point'],
    ['.gcm-points-supplyGeneric', 'Supply Point (Generic)'],

    ['.gcm-points-natocl1', 'NATO Class I Supply Point'],
    ['.gcm-points-uscl1', 'Class I Supply Point', undefined, undefined, undefined, undefined, 'U.S. Class I Supply Point'],
    ['.gcm-points-natouscl2', 'Class II Supply Point', undefined, undefined, undefined, undefined, 'NATO & U.S. Class II Supply Point'],

    ['.gcm-points-natocl3', 'NATO Class III Supply Point'],
    ['.gcm-points-uscl3', 'Class III Supply Point', undefined, undefined, undefined, undefined, 'U.S. Class III Supply Point'],
    ['.gcm-points-natocl4', 'NATO Class IV Supply Point'],

    ['.gcm-points-uscl4', 'Class IV Supply Point', undefined, undefined, undefined, undefined, 'U.S. Class IV Supply Point'],
    ['.gcm-points-natouscl5', 'Class V Supply Point', undefined, undefined, undefined, undefined, 'NATO & U.S. Class V Supply Point'],
    ['.gcm-points-uscl6', 'Class VI Supply Point', undefined, undefined, undefined, undefined, 'U.S. Class VI Supply Point'],

    ['.gcm-points-uscl7', 'Class VII Supply Point', undefined, undefined, undefined, undefined, 'U.S. Class VII Supply Point'],
    ['.gcm-points-natouscl8', 'Class VIII Supply Point', undefined, undefined, undefined, undefined, 'NATO & U.S. Class VIII Supply Point'],
    ['.gcm-points-uscl9', 'Class IX Supply Point', undefined, undefined, undefined, undefined, 'U.S. Class IX Supply Point'],

    ['.gcm-points-uscl10', 'Class X Supply Point', undefined, undefined, undefined, undefined, 'U.S. Class X Supply Point'],
    ['.gcm-points-nmscp', 'NATO Multiple Supply Class Point'],
    ['.gcm-points-airfield', 'Airfield'],

    ['.gcm-points-contact', 'Contact Point'],
    ['.gcm-points-dp', 'Decision Point'],
    ['.gcm-points-kt', 'Key Terrain'],

    ['.gcm-points-poi', 'Point of Interest (Launch Event)', undefined, undefined, undefined, undefined, 'Point of Interest'],
    ['.gcm-points-wp', 'Waypoint'],
    ['.gcm-points-th', 'Target Handover'],
  ],

  'gcm-icons-mam': [
    ['.gcm-mam-aviationAoA', 'Airborne Axis of Advance'],
    ['.gcm-mam-attackHelicopterAoA', 'Attack Helicopter Axis of Advance'],
    ['.gcm-mam-mainAoA', 'Main Axis of Advance'],

    ['.gcm-mam-abf', 'Attack by Fire'],
    ['.gcm-mam-sbf', 'Support by Fire'],
    ['.gcm-mam-adoa', 'Aviation Direction of Attack'],

    ['.gcm-mam-doma', 'Direction of Main Attack'],
    ['.gcm-mam-cak', 'Cordon and Knock'],
    ['.gcm-mam-cas', 'Cordon and Search'],

    ['.gcm-mam-ambush', 'Ambush'],
    ['.gcm-mam-catk', 'Counterattack (Right)', undefined, undefined, undefined, undefined, 'Counterattack'],
    ['.gcm-mam-dem', 'Demonstration'],

    ['.gcm-mam-feint', 'Feint'],
    ['.gcm-mam-screen', 'Screen'],
    ['.gcm-mam-cover', 'Cover'],

    ['.gcm-mam-guard', 'Guard'],
    ['.gcm-mam-fpol', 'Forward Passage of Lines'],
    ['.gcm-mam-rpol', 'Rearward Passage of Lines'],

    ['.gcm-mam-rip', 'Relief in Place'],
    ['.gcm-mam-delay', 'Delay'],
    ['.gcm-mam-retirement', 'Retirement'],

    ['.gcm-mam-withdraw', 'Withdraw'],
    ['.gcm-mam-wup', 'Withdraw Under Pressure'],
  ],

  'gcm-icons-op': [
    ['.gcm-op-op', 'Observation Post'],
    ['.gcm-op-rop', 'Reconnaissance Outpost'],
    ['.gcm-op-fo', 'Forward Observer Outpost'],

    ['.gcm-op-cbrnop', 'CBRN Outpost', undefined, undefined, undefined, undefined, 'CBRN Observation Post'],
    ['.gcm-op-sop', 'Sensor Observation Post'],
    ['.gcm-op-cop', 'Combat Observation Post'],
  ],

  'gcm-icons-air': [
    ['.gcm-air-ascp', 'Airspace Control Points'],
    ['.gcm-air-acp', 'Air Control Point'],
    ['.gcm-air-ccp', 'Communications Checkpoint'],

    ['.gcm-air-dapp', 'Downed Aircrew Pickup Point'],
    ['.gcm-air-pop', 'Popup Point'],
    ['.gcm-air-acr', 'Air Control Rendezvous'],

    ['.gcm-air-tacan', 'Tactical Air Navigation (TACAN)'],
    ['.gcm-air-sip', 'Strike Initial Point'],
    ['.gcm-air-rs', 'Replenishment Station'],

    ['.gcm-air-uas', 'Unmanned Aerial System (UAS/UAV)'],
    ['.gcm-air-vtoluas', 'VTOL/VTUA'],
    ['.gcm-air-caps', 'Combat Air Patrol (CAP) Station'],

    ['.gcm-air-rescuePoint', 'Rescue Point'],
    ['.gcm-air-aews', 'Airborne Early Warning (AEW) Station'],
    ['.gcm-air-sucap', 'Surface Combat Air Patrol (SUCAP)'],
  ],

  'gcm-icons-maritime': [
    ['.gcm-maritime-of', 'Optical Fix'],
    ['.gcm-maritime-formation', 'Formation'],
    ['.gcm-maritime-hep', 'Harbor Entrance Point'],

    ['.gcm-maritime-mrp', 'Maritime Reference Point'],
    ['.gcm-maritime-msp', 'Maritime Special Point'],
    ['.gcm-maritime-mnrp', 'Maritime Navigational Reference Point'],

    ['.gcm-maritime-dlrp', 'Maritime Data Link Point'],
    ['.gcm-maritime-ctp', 'Maritime Corridor Tab Point'],
    ['.gcm-maritime-mp', 'Maritime Marshall Point'],

    ['.gcm-maritime-pim', 'Maritime Position & Intended Movement'],
    ['.gcm-maritime-plw', 'Maritime Pre-Landfall Waypoint'],
    ['.gcm-maritime-mep', 'Maritime Estimated Position'],

    ['.gcm-maritime-mw', 'Maritime Waypoint'],

    ['.gcm-maritime-gsss', 'General Sea Subsurface Station'],
    ['.gcm-maritime-ncsss', 'Non-Combatant Sea Surface Station'],
    ['.gcm-maritime-rsss', 'Rendezvous Sea Surface Station'],

    ['.gcm-maritime-rasss', 'Replenishment Sea Surface Station'],
    ['.gcm-maritime-rss', 'Rescue Sea Surface Station'],
    ['.gcm-maritime-scs', 'Shore Control Station'],

    ['.gcm-maritime-dv', 'Distressed Vessel'],
    ['.gcm-maritime-downed', 'Downed Aircraft'],
    ['.gcm-maritime-piw', 'Person in Water'],

    ['.gcm-maritime-iceberg', 'Iceberg'],
    ['.gcm-maritime-oilrig', 'Oil Rig'],
    ['.gcm-maritime-sml', 'Sea mine-like'],
  ],

  'gcm-icons-tgt': [
    ['.gcm-tgt-trp', 'Target Reference Point Example', undefined, undefined, undefined, undefined, 'Target Reference Point'],
    ['.gcm-tgt-pt', 'Point Target'],
    ['.gcm-tgt-nt', 'Nuclear Target'],

    ['.gcm-tgt-linear', 'Linear Target'],
    ['.gcm-tgt-lst', 'Linear Smoke Target'],
    ['.gcm-tgt-fpf', 'Final Protective Fires'],

    ['.gcm-tgt-got', 'Group of Targets'],
    ['.gcm-tgt-bat', 'Bomb Area Target'],
    ['.gcm-tgt-fss', 'Fire Support Station'],
  ],

  'gcm-icons-mcm': [
    ['.gcm-mcm-obe', 'Obstacle Bypass (Easy)'],
    ['.gcm-mcm-obd', 'Obstacle Bypass (Difficult)'],
    ['.gcm-mcm-obi', 'Obstacle Bypass (Impossible)'],

    ['.gcm-mcm-gap', 'Gap'],
    ['.gcm-mcm-pl', 'Passage Lane'],
    ['.gcm-mcm-bridge', 'Bridge (Mobility)'],

    ['.gcm-mcm-fe', 'Ford (Easy)'],
    ['.gcm-mcm-fd', 'Ford (Difficult)'],
    ['.gcm-mcm-ferry', 'Ferry Crossing'],

    ['.gcm-mcm-block', 'Block'],
    ['.gcm-mcm-disrupt', 'Disrupt'],
    ['.gcm-mcm-fix', 'Fix'],

    ['.gcm-mcm-turn', 'Turn'],
    ['.gcm-mcm-ol', 'Obstacle Line'],
    ['.gcm-mcm-pesor', 'Planned Explosives State of Readiness'],

    ['.gcm-mcm-esor1', 'Explosives State of Readiness 1 (Safe)'],
    ['.gcm-mcm-esor2', 'Explosives State of Readiness 2 (Armed but Passable)'],
    ['.gcm-mcm-roadblock', 'Roadblock Complete (Executed)'],

    ['.gcm-mcm-abatis', 'Abatis'],
    ['.gcm-mcm-wou', 'Wire Obstacle (Unspecified)'],
    ['.gcm-mcm-wosf', 'Wire Obstacle (Single Fence)'],

    ['.gcm-mcm-wodf', 'Wire Obstacle (Double Fence)'],
    ['.gcm-mcm-wodaf', 'Wire Obstacle (Double Apron Fence)'],
    ['.gcm-mcm-wolwf', 'Wire Obstacle (Low Wire Fence)'],

    ['.gcm-mcm-wohwf', 'Wire Obstacle (High Wire Fence)'],
    ['.gcm-mcm-wosc', 'Wire Obstacle (Single Strand Concertina)'],
    ['.gcm-mcm-wodsc', 'Wire Obstacle (Double Strand Concertina)'],

    ['.gcm-mcm-wotsc', 'Wire Obstacle (Triple Strand Concertina)'],
    ['.gcm-mcm-atduc', 'Antitank Ditch (Under Construction)'],
    ['.gcm-mcm-atdc', 'Antitank Ditch (Completed)'],

    ['.gcm-mcm-atdrwatm', 'Antitank Ditch Reinforced with AT Mines'],
    ['.gcm-mcm-fapato', 'Fixed and Prefabricated Antitank Obstacle'],
    ['.gcm-mcm-mato', 'Moveable Antitank Obstacle'],

    ['.gcm-mcm-mapato', 'Moveable and Prefabricated Antitank Obstacle'],
    ['.gcm-mcm-atw', 'Antitank Wall'],
  ],

  'gcm-icons-mines': [
    ['.gcm-mines-apm', 'Antipersonnel Mine'],
    ['.gcm-mines-apmwde', 'Antipersonnel Mine with Directional Effects'],
    ['.gcm-mines-atm', 'Antitank Mine'],

    ['.gcm-mines-atmwahd', 'Antitank Mine with Antihandling Device'],
    ['.gcm-mines-waat', 'Wide Area Antitank Mine'],
    ['.gcm-mines-um', 'Unspecified Mine'],

    ['.gcm-mines-bt', 'Boobytrap Mine'],
    ['.gcm-mines-tw', 'Tripwire Mine'],
    ['.gcm-minefield-um', 'Unspecified Mines'],

    ['.gcm-minefield-apm', 'Antipersonnel Mines'],
    ['.gcm-minefield-apmwde', 'Antipersonnel Mines w/Directional Effects'],
    ['.gcm-minefield-atm', 'Antitank Mines'],

    ['.gcm-minefield-atmwahd', 'Antitank Mines w/Antihandling Device'],
    ['.gcm-minefield-waatm', 'Wide Area Antitank Mines'],
    ['.gcm-minefield-mc', 'Mine Cluster'],

    ['.gcm-minefield-apmaapmwde', 'AP Mines & AP Mine w/Directional Effects'],
    ['.gcm-minefield-apmaatm', 'AP Mines & AT Mine'],
    ['.gcm-minefield-apmaatmwahd', 'AP Mines & AT Mine w/Antihandling Device'],

    ['.gcm-minefield-mf11', 'AP Mines & Wide Area AT Mine'],
    ['.gcm-minefield-mf12', 'AP Mines & Mine Cluster'],
    ['.gcm-minefield-mf13', 'AP Mines w/Directional Effects & AT Mine'],

    ['.gcm-minefield-mf14', 'AP Mines w/Dir FX & AT Mine w/Antihandling device'],
    ['.gcm-minefield-mf15', 'AP Mine w/Dir FX & Wide Area AT Mine'],
    ['.gcm-minefield-mf16', 'AP Mine w/Dir FX & Mine Cluster'],

    ['.gcm-minefield-mf17', 'AT Mines & AT Mine w/Antihandling Device'],
    ['.gcm-minefield-mf18', 'AT Mines & Wide Area AT Mine'],
    ['.gcm-minefield-mf19', 'AT Mines & Mine Cluster'],

    ['.gcm-minefield-mf20', 'AT Mines w/AH Device & Wide Area AT Mine'],
    ['.gcm-minefield-mf21', 'AT Mines w/AH Device & Mine Cluster'],
    ['.gcm-minefield-mf22', 'Wide Area AT Mines & Mine Cluster'],

    ['.gcm-minefield-mf23', 'AP Mine & AP Mine w/Dir FX & AT Mine'],
    ['.gcm-minefield-mf24', 'AP Mine & AP Mine w/Dir FX & AT Mine w/AH'],
    ['.gcm-minefield-mf25', 'AP Mine & AP Mine w/Dir FX & WA AT Mine'],

    ['.gcm-minefield-mf26', 'AP Mine & AP Mine w/Dir FX & Mine Cluster'],
    ['.gcm-minefield-mf27', 'AP Mine & AT Mine & AT Mine w/AH Device'],
    ['.gcm-minefield-mf28', 'AP Mine & AT Mine & Wide Area AT Mine'],

    ['.gcm-minefield-mf29', 'AP Mine & AT Mine & Mine Cluster'],
    ['.gcm-minefield-mf30', 'AP Mine & AP Mine w/AH Dev. & WA AT Mine'],
    ['.gcm-minefield-mf31', 'AP Mine & AT Mine w/AH Dev. & Mine Cluster'],

    ['.gcm-minefield-mf32', 'AP Mine & Wide Area AT Mine & Mine Cluster'],
    ['.gcm-minefield-mf33', 'AP Mine w/Dir FX & AT Mine & AT Mine w/AH'],
    ['.gcm-minefield-mf34', 'AP Mine w/Dir FX & AT Mine & WA AT Mine'],

    ['.gcm-minefield-mf35', 'AP Mine w/Dir FX & AT Mine & Mine Cluster'],
    ['.gcm-minefield-mf36', 'AP Mine w/Dir FX & AT Mine w/AH & WA AT'],
    ['.gcm-minefield-mf37', 'AP Mine w/Dir FX & AT Mine w/AH & Cluster'],

    ['.gcm-minefield-mf38', 'AP Mine w/Dir FX & WA AT Mine & Cluster'],
  ],

  'gcm-icons-fortifications': [
    ['.gcm-fortifications-s', 'Shelter'],
    ['.gcm-fortifications-ags', 'Above Ground Facility'],
    ['.gcm-fortifications-uf', 'Underground Facility'],

    ['.gcm-fortifications-f', 'Fort'],
    ['.gcm-fortifications-fl', 'Fortified Line'],
    ['.gcm-fortifications-fp', 'Fighting Position'],
  ],

  'gcm-icons-cbrn': [
    ['.gcm-cbrn-c', 'Chemical Event'],
    ['.gcm-cbrn-b', 'Biological Event'],
    ['.gcm-cbrn-r', 'Radiological Event'],

    ['.gcm-cbrn-n', 'Nuclear Event'],
    ['.gcm-cbrn-cca', 'Chemical Contaminated Area'],
    ['.gcm-cbrn-bca', 'Biological Contaminated Area'],

    ['.gcm-cbrn-rca', 'Radiological Contaminated Area'],
    ['.gcm-cbrn-nca', 'Nuclear Contaminated Area'],
  ],

  'gcm-icons-route': [
    ['.gcm-route-r', 'Route'],
    ['.gcm-route-owt', 'One Way Traffic'],
    ['.gcm-route-twt', 'Two Way Traffic'],

    ['.gcm-route-ar', 'Alternating Traffic'],
    ['.gcm-route-msr', 'Main Supply Route'],
    ['.gcm-route-asr', 'Alternate Supply Route'],
  ],
};

export default cardObj;
